import * as $ from 'jquery';
import {Global} from "../init-global";
import { TweenLite, TimelineLite, Sine } from 'gsap';
const activated = [ TweenLite, TimelineLite, Sine ];

require("waypoints/lib/jquery.waypoints.js");


export class HistoryFeature
{
	protected $root: JQuery;
	protected triggerObj: Waypoint;
	protected tl:TimelineLite;
    protected $title:JQuery;
    protected $letter:JQuery;


	constructor(elem: HTMLElement)
    {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI() {
        this.$title  = $('.l-yoo-story__title', this.$root);
        this.$letter = $('i', this.$title);

        if (typeof this.triggerObj != 'undefined') {
            this.triggerObj.destroy();
            this.reset();
        }

    	this.triggerObj = new Waypoint({
		  element: this.$root.get(0),
		  handler: (direction:any) => {
		  	this.doAnimation(direction);
		  },
		  offset: '65%'
		})
    }

    public reset = () => {
    	this.$root.removeClass('dsp-triggered');
    }

    private doAnimation = (direction:any) => {
        if (typeof this.tl != 'undefined') {
            this.tl.clear();
        }

		this.tl = new TimelineLite({ onComplete: () => { 
			if (direction != 'down') {
				this.$title.removeClass('dsp-letter dsp-bite dsp-rotate');
			}
		}});
		 
		if (direction == 'down') {
			TweenLite.set(this.$title, { css: { opacity: 0, y: '+=50' }});
			this.tl.to(this.$title, 0.6, { y:'0', ease: Sine.easeInOut  })
			.to(this.$title, 0.7, { opacity: 1, ease: Sine.easeOut}, 0)
			.add(() => { this.$title.addClass('dsp-letter'); }, '+=0.5')
			.add(() => { this.$title.addClass('dsp-bite'); }, '+=1')
			.add(() => { this.$title.addClass('dsp-rotate'); }, '+=0.5');
		} else {
			TweenLite.set(this.$title, { css: { opacity: 1, y: '0' }});
			this.tl.to(this.$title, 0.6, { y:'+=50', ease: Sine.easeInOut })
			.to(this.$title, 0.7, { opacity: 0, ease: Sine.easeOut}, 0);
		}
	}
}